var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"direction -border"},_vm._l((_vm.KANT_BORDERS),function(item,key){
var _obj;
return _c('li',{key:key,class:( _obj = {}, _obj[("kant-" + item)] = true, _obj.active_direction = _vm.value.indexOf(item) !== -1, _obj ),attrs:{"data-border":item.toUpperCase()},on:{"click":function($event){return _vm.select(item)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }